import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => {})
};
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/login/register')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/home')
      },
      {
        path: '/us',
        name: 'us',
        component: () => import('@/views/us/us')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/login')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/personal/account'),
        meta: {
          keepAlive: true
        }
      },
      /* {
        path: '/exams',
        name: 'exams',
        component: () => import('@/views/exam/exams')
      },
      {
        path: '/exam-details',
        name: 'exam-details',
        component: () => import('@/views/exam/examDetails')
      },
      {
        path: '/start-exam-a/:id',
        name: 'start-exam-a',
        component: () => import('@/views/exam/startExamA')
      },
      {
        path: '/start-exam-b/:id',
        name: 'start-exam-b',
        component: () => import('@/views/exam/startExamB')
      },
      {
        path: '/exam-record',
        name: 'exam-record',
        component: () => import('@/views/exam/examRecords')
      }, */
      {
        path: '/teacher',
        name: 'teacher',
        component: () => import('@/views/teacher/teacher')
      },
      {
        path: '/teacher-detail',
        name: 'teacher-detail',
        component: () => import('@/views/teacher/teacherDetail')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/knowledge/index')
      },
      {
        path: '/knowledge-file',
        name: 'knowledge-file',
        component: () => import('@/views/knowledge/infoKnowledgeFile')
      },
      {
        path: '/knowledge-image',
        name: 'knowledge-image',
        component: () => import('@/views/knowledge/infoKnowledge')
      },
      {
        path: '/question',
        name: 'question',
        component: () => import('@/views/question/question')
      },
      {
        path: '/question-detail',
        name: 'question-detail',
        component: () => import('@/views/question/questionDetail')
      },
      {
        path: '/community',
        name: 'community',
        component: () => import('@/views/question/community')
      },
      {
        path: '/community-detail',
        name: 'community-detail',
        component: () => import('@/views/question/communityDetail')
      },
      {
        path: '/courses',
        name: 'courses',
        component: () => import('@/views/course/course')
      },
      {
        path: '/tiny-course',
        name: 'tiny-course',
        component: () => import('@/views/course/tinyCourse')
      },
      {
        path: '/course-detail',
        name: 'course-detail',
        component: () => import('@/views/course/courseDetail')
      },
      {
        path: '/course-rank',
        name: 'course-rank',
        component: () => import('@/views/course/courseRank')
      },
      {
        path: '/course-purchase',
        name: 'course-purchase',
        component: () => import('@/views/course/coursePurchase')
      },
      {
        path: '/task',
        name: 'task',
        component: () => import('@/views/task/task'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/task-detail',
        name: 'task-detail',
        component: () => import('@/views/task/taskDetail')
      },
      {
        path: '/examine-detail',
        name: 'examine-detail',
        component: () => import('@/views/examine/examineDetail')
      },
      {
        path: '/examine-result',
        name: 'examine-result',
        component: () => import('@/views/examine/examineResult')
      },
      {
        path: '/examine-record',
        name: 'examine-record',
        component: () => import('@/views/examine/examineRecord')
      },
      {
        path: '/start-examine',
        name: 'start-examine',
        component: () => import('@/views/examine/startExamine')
      },
      {
        path: '/view-examine',
        name: 'view-examine',
        component: () => import('@/views/examine/viewExamine')
      },
      {
        path: '/after-detail',
        name: 'after-detail',
        component: () => import('@/views/course/courseAfter/afterDetail')
      },
      {
        path: '/after-result',
        name: 'after-result',
        component: () => import('@/views/course/courseAfter/afterResult')
      },
      {
        path: '/start-after',
        name: 'start-after',
        component: () => import('@/views/course/courseAfter/startAfter')
      },
      {
        path: '/view-after',
        name: 'view-after',
        component: () => import('@/views/course/courseAfter/viewAfter')
      },
      {
        path: '/program-detail',
        name: 'program-detail',
        component: () => import('@/views/program/programDetail')
      },
      {
        path: '/program-work',
        name: 'program-work',
        component: () => import('@/views/program/programWork')
      },
      {
        path: '/event-detail',
        name: 'event-detail',
        component: () => import('@/views/event/eventDetail')
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product/product')
      },
      {
        path: '/product-detail',
        name: 'product-detail',
        component: () => import('@/views/product/productDetail')
      },
      {
        path: '/product-wheel',
        name: 'product-wheel',
        component: () => import('@/views/product/wheelList')
      },
      {
        path: '/notice-detail',
        name: 'notice-detail',
        component: () => import('@/views/notice/noticeDetail')
      },
      {
        path: '/my-medal',
        name: 'my-medal',
        component: () => import('@/views/personal/myMedal')
      },
      {
        path: '/questionnaire',
        name: 'questionnaire',
        component: () => import('@/views/questionnaire/questionnaireList')
      },
      {
        path: '/questionnaire-detail',
        name: 'questionnaire-detail',
        component: () => import('@/views/questionnaire/questionnaireDetail')
      },
      {
        path: '/questionnaire-result',
        name: 'questionnaire-result',
        component: () => import('@/views/questionnaire/questionnaireResult')
      },
      {
        path: '/questionnaire-info',
        name: 'questionnaire-info',
        component: () => import('@/views/questionnaire/questionnaireInfo')
      },
      {
        path: '/tip',
        name: 'tip',
        component: () => import('@/views/login/tip')
      },
      /* {
        path: '/ceshi',
        name: 'ceshi',
        component: () => import('@/views/ceshi')
      },
      {
        path: '/course-section',
        name: 'course-section',
        component: () => import('@/views/exam/section')
      },
      {
        path: '/incorrect',
        name: 'incorrect',
        component: () => import('@/views/exam/incorrect')
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/personal/resetPassword')
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/exam/search')
      } */
    ]
  },
  /* {
    path: '/mobile',
    name: 'mobile',
    component: () => import('@/views/mobile/index')
  },
  {
    path: '/mobile-finished',
    name: 'mobile-finished',
    component: () => import('@/views/mobile/finished')
  }, */
  {
    path: '*',
    redirect: '/home'
  }
]
export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: [0, 1] }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js